import {
  SlDrawer,
  SlButton,
  SlTooltip,
  SlIcon,
  SlSelect,
  SlOption,
} from "@shoelace-style/shoelace/dist/react";
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import API from "../../services/api";
import { Toast } from "../../shared/Toast";
import TableSkelton from "../../shared/TableSkelton";
import NoDataFound from "../../shared/NoDataFound";
import config from "../../config";
import ScrollContainer from "react-indiana-drag-scroll";
import { roles } from "../../utils/constants";
import { formatDate, formatDateWithTime } from "../../utils/dateFormat";
import Paginator from "../../shared/Paginator";
import { Modal, ModalBody, ModalHeader, ModalTitle } from "react-bootstrap";
import { useNavigate } from "react-router";

function Help() {
  const navigate = useNavigate();
  const form1 = useForm({
    mode: "onSubmit",
  });
  const form2 = useForm({
    mode: "onSubmit",
  });
  const form3 = useForm({
    mode: "onSubmit",
  });
  const watchType = form1.watch("type", "1");
  const watchDescription = form1.watch("description");
  const watchUpdate = form2.watch("description");
  const watchReason = form3.watch("update");
  function handleRequestClose(event) {
    if (event.detail.source === "overlay") {
      event.preventDefault();
    }
  }
  const [open, setOpen] = useState(false);
  const [loader, setLoader] = useState(false);
  const [currentpage, setCurrentPage] = useState(0);
  const [submitLoader, setSubmitLoader] = useState(false);
  const [previewMedia, setPreviewMedia] = useState(null);
  const [media, setMedia] = useState(null);
  const [data, setData] = useState([]);
  const [preview, setPreview] = useState(false);
  const [helpData, setHelpData] = useState(null);
  const [updateStatus, setUpdateStatus] = useState(false);
  const [showUpdates, setShowUpdates] = useState(false);
  const [updates, setUpdates] = useState([]);
  const [status, setStatus] = useState("all");
  const [type,setType] = useState("all");
  const [totalPages, setTotalPages] = useState(0);
  const [deleteClicked, setDeleteClicked] = useState(false);
  const [deleteId, setDeleteId] = useState(null);
  const statusMappings = {
    1: "Pending",
    2: "In Progress",
    3: "Resolved",
    4: "Ignore",
  };

  const loadData = async () => {
    setLoader(true);
    try {
      let res = await API({
        url: "/help/get",
        method: "POST",
        responseType: "json",
        data: {
          page: currentpage,
          limit: config.PER_PAGE,
          status,
          type
        },
      });
      if (res.code === 200) {
        setData(res.data?.data);
        setTotalPages(Math.round(res.data?.total / config.PER_PAGE));
      } else if (res.code === 401) navigate("/");
    } catch (error) {
    } finally {
      setLoader(false);
    }
  };

  const addIssue = async (data) => {
    let media_url = await uploadMedia();
    setSubmitLoader(true);
    try {
      let res = await API({
        url: "/help/addIssue",
        method: "POST",
        responseType: "json",
        data: {
          type: data.type,
          description: data.description,
          media: media_url,
          brand_name: data.type === "1" ? data.brand_name : undefined,
          title:data.title
        },
      });
      if (res.code === 200) {
        setOpen(false);
        form1.reset();
        setCurrentPage(0);
        loadData();
        setPreviewMedia(null);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setSubmitLoader(false);
    }
  };

  const uploadMedia = async () => {
    const formData = new FormData();
    formData.append("files", media);
    try {
      let res = await API({
        url: "/upload/help",
        method: "POST",
        responseType: "json",
        headers: { "Content-Type": "multipart/form-data" },
        data: formData,
      });
      if (res.code === 200) {
        return res.data;
      }
    } catch (error) {
      console.error(error, "Error while uplaoding");
      Toast("error", "Error while uploading");
    }
  };
  const handleMediaPreview = (event) => {
    const file = event.target.files[0];
    setMedia(file);
    if (file) {
      const fileURL = URL.createObjectURL(file);
      setPreviewMedia({
        url: fileURL,
        type: file.type.startsWith("video") ? "video" : "image",
      });
    }
  };

  const handlePreview = (url) => {
    const type = url.split(".")?.pop();
    setPreviewMedia({
      url: url,
      type: type === "mp4" ? "video" : "image",
    });
    setPreview(true);
  };
  const handleUpdateHelp = async (data) => {
    setSubmitLoader(true);
    try {
      let res = await API({
        url: "/help/update",
        method: "POST",
        responseType: "json",
        data: {
          id: helpData.id,
          status: data.status,
          update: data.description,
          data:helpData
        },
      });
      if (res.code === 200) {
        setUpdateStatus(false);
        setHelpData(null);
        loadData();
        form2.reset();
      }
    } catch (error) {
    } finally {
      setSubmitLoader(false);
    }
  };
  const handleIgnore = async (data) => {
    setSubmitLoader(true);
    try {
      let res = await API({
        url: "/help/ignore",
        method: "POST",
        responseType: "json",
        data: {
          id: deleteId,
          update: data.update,
          status: 4,
        },
      });
      if (res.code === 200) {
        loadData();
        setDeleteClicked(false);
        setDeleteId(null);
        form3.reset();
      }
    } catch (error) {
      console.error(error);
      Toast("error", "Someting went wrong");
    } finally {
      setSubmitLoader(false);
    }
  };
  useEffect(() => {
    loadData();
  }, [status, type]);

  const handlePageClick = (event) => {
    setCurrentPage(event.selected);
    loadData(event.selected);
  };

  return (
    <>
      <div className="justify-between flex my-2">
        <h5>Tickets</h5>
        <aside className="flex gap-3 items-end">
        <SlSelect
            label="Type"
            value={type}
            className="min-w-[120px]"
            onSlChange={(e) => setType(e.target.value)}
            size="small"
          >
            <SlOption value="all">All</SlOption>
            <SlOption value={1}>Misrepresentation</SlOption>
            <SlOption value={2}>Issue</SlOption>
            <SlOption value={3}>Requirement</SlOption>
          </SlSelect>
          <SlSelect
            label="Status"
            value={status}
            onSlChange={(e) => setStatus(e.target.value)}
            size="small"
          >
            <SlOption value="all">All</SlOption>
            <SlOption value={1}>Pending</SlOption>
            <SlOption value={2}>In Progress</SlOption>
            <SlOption value={3}>Resolved</SlOption>
            <SlOption value={4}>Ignore</SlOption>
          </SlSelect>
          <SlButton
            variant="primary"
            size="small"
            onClick={() => {
              setOpen(true);
              form1.reset();
              setPreviewMedia(null);
            }}
          >
           <span className="block sm:hidden">+</span> 
           <span className="mobHide !sm:block">Add Ticket</span>
          </SlButton>
        </aside>
      </div>
      <ScrollContainer>
        <table className="table table-bordered">
          <thead className="bg-gray-50">
            <tr>
              <th>S.No</th>
              <th>Type</th>
              <th>Brand</th>
              <th>Title</th>
              <th>Description</th>
              <th>Created Date</th>
              <th>Created by</th>
              <th>Status</th>
              <th>Actions</th>
            </tr>
          </thead>
          {!loader && data.length > 0 ? (
            <tbody className="help">
              {data.map((item, index) => (
                <tr key={index}>
                  <td>{index + 1}</td>
                  <td>{item.type === 1 ? "Misrepresentation" : item.type === 2 ? "Issue" : 'Requirement'}</td>
                  <td>{item.type === 1 ? item.brand_name : ""}</td>
                  <td title={item.title}>{item.title}</td>
                  <td title={item.description} className="break-words !whitespace-normal max-w-sm line-clamp">
                    {item.description}
                  </td>
                  <td>{formatDate(item.created_on)}</td>
                  <td>{item.name}</td>
                  <td>
                    <span
                      className={`px-2 py-1 rounded-md  ${
                        item.status === 1
                          ? "bg-yellow-300 text-black"
                          : item.status === 2
                          ? "bg-blue-300 !text-blue-800"
                          : item.status === 3
                          ? "bg-green-300 !text-green-900"
                          : "bg-gray-400 !text-gray-800"
                      } `}
                    >
                      {item.status === 1
                        ? "Pending"
                        : item.status === 2
                        ? "In Progress"
                        :item.status === 3       
                        ? "Resolved" : 'Ignore'}
                    </span>
                  </td>
                  <td>
                    <div className="flex gap-3">
                      <SlTooltip content="preview">
                        <SlIcon
                          name="eye"
                          className="cursor-pointer w-4 h-4 hover:text-sky-300"
                          library="lucide"
                          onClick={() => handlePreview(item.media_url)}
                        ></SlIcon>
                      </SlTooltip>
                      {localStorage.getItem("role") === roles.salesperson &&
                        item.status !== 3 &&
                        item.status !== 4 && (
                          <SlTooltip content="Delete">
                            <SlIcon
                              name="trash-2"
                              className="cursor-pointer w-4 h-4 hover:text-red-500"
                              //   size="16"
                              onClick={() => {
                                setDeleteId(item.id);
                                setDeleteClicked(true);
                              }}
                              library="lucide"
                            />
                          </SlTooltip>
                        )}
                      {localStorage.getItem("role") === roles.b2b && (
                        <SlTooltip content="Edit">
                          <SlIcon
                            name="edit"
                            className="cursor-pointer w-4 h-4 hover:text-sky-300"
                            onClick={() => {
                              setUpdateStatus(true);
                              form2.setValue("status", item.status);
                              setHelpData(item);
                            }}
                            //   size="16"
                            library="lucide"
                          />
                        </SlTooltip>
                      )}
                      <SlTooltip content="View Updates">
                        <SlIcon
                          name="bell"
                          className="cursor-pointer w-4 h-4 hover:text-sky-300"
                          onClick={() => {
                            setShowUpdates(true);
                            setHelpData(item);
                            setUpdates(item.updates);
                          }}
                          library="lucide"
                        />
                      </SlTooltip>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          ) : loader ? (
            <TableSkelton colspan={7} />
          ) : (
            <NoDataFound colspan={7} />
          )}
        </table>
      </ScrollContainer>
      <div className=" right-fixed mt-4">
        {totalPages > 1 && (
          <Paginator
            pageCount={totalPages}
            handlePageClick={handlePageClick}
            forcePage={currentpage}
          />
        )}
      </div>
      {open && (
        <SlDrawer
          open={open}
          label="Ticket"
          onSlRequestClose={handleRequestClose}
          onSlAfterHide={() => {
            setOpen(false);
          }}
          style={{ "--size": window.innerWidth > 768 ? "40%" : "100%" }}
        >
          <div className="d-flex gap-3 flex-wrap">
            <form onSubmit={form1.handleSubmit(addIssue)}>
              <div class="form-check form-check-inline">
                <input
                  class="form-check-input"
                  type="radio"
                  id="inlineRadio1"
                  value={"1"}
                  {...form1.register("type")}
                  defaultChecked
                />
                <label class="form-check-label" for="inlineRadio1">
                  Misrepresentation
                </label>
              </div>
              <div class="form-check form-check-inline">
                <input
                  class="form-check-input"
                  type="radio"
                  id="inlineRadio2"
                  value={"2"}
                  {...form1.register("type")}
                />
                <label class="form-check-label" for="inlineRadio2">
                  Issue
                </label>
              </div>
              <div class="form-check form-check-inline">
                <input
                  class="form-check-input"
                  type="radio"
                  id="inlineRadio3"
                  value={"3"}
                  {...form1.register("type")}
                />
                <label class="form-check-label" for="inlineRadio3">
                  Requirement
                </label>
              </div>
              <hr></hr>

              {watchType === `1` || watchType === undefined ? (
                <div class="mb-3">
                  <label className="form-label" htmlFor="brand name">
                    Brand Name
                  </label>
                  <span className="text-red-600">*</span>
                  <input
                    class="form-control"
                    type="text"
                    placeholder="Brand Name"
                    aria-label="brand name"
                    id="brand name"
                    {...form1.register("brand_name", { required: true })}
                  ></input>
                  {form1.formState?.errors?.brand_name && (
                    <p className="text-red-600">Please Enter Brand Name</p>
                  )}
                </div>
              ) : null}
              <div class="mb-3">
                  <label className="form-label" htmlFor="title">
                    Title
                  </label>
                  <span className="text-red-600">*</span>
                  <input
                    class="form-control"
                    type="text"
                    placeholder="Title"
                    aria-label="title"
                    id="title"
                    {...form1.register("title", { required: true })}
                  ></input>
                  {form1.formState?.errors?.title && (
                    <p className="text-red-600">Please Enter Title</p>
                  )}
                </div>
              <div className="mb-3">
                <label className="form-label" htmlFor="media_url">
                  Upload Image / Video
                </label>
                <span className="text-red-600">*</span>
                <input
                  class="form-control"
                  type="file"
                  placeholder="Upload Media"
                  aria-label="media_url"
                  id="media_url"
                  {...form1.register("media_url", {
                    required: true,
                    onChange: (e) => handleMediaPreview(e),
                  })}
                ></input>
                {form1.formState?.errors?.media_url && (
                  <p className="text-red-600">Please upload Media</p>
                )}
              </div>
              <div class="mb-3">
                <label htmlFor="description" class="form-label">
                  Description
                </label>
                <span className="text-red-600">*</span>&nbsp;&nbsp;{" "}
                <span
                  className={`${
                    watchDescription?.length > 300
                      ? "text-red-600"
                      : "text-green-500"
                  }`}
                >
                  {300 - watchDescription?.length || 300}
                </span>
                <textarea
                  class="form-control"
                  id="description"
                  rows="3"
                  {...form1.register("description", {
                    required: true,
                    minLength: 1,
                    maxLength: 300,
                  })}
                ></textarea>
                {form1.formState?.errors?.description?.type === "maxLength" && (
                  <p className="text-red-600">Too many Characthers</p>
                )}
                {form1.formState?.errors?.description
                  ? form1.formState?.errors?.description?.type !==
                      "maxLength" && (
                      <p className="text-red-600">Please Enter description</p>
                    )
                  : null}
              </div>
              <div class="mb-3">
                <button className="btn btn-primary w-full" type="submit">
                  {submitLoader && (
                    <span
                      className="spinner-grow spinner-grow-sm"
                      role="status"
                      aria-hidden="true"
                    ></span>
                  )}
                  {submitLoader ? "Submitting..." : "Submit"}
                </button>
              </div>
            </form>
            <div className="!max-w-[360px] ">
              {previewMedia ? (
                previewMedia.type === "image" ? (
                  <img
                    src={previewMedia.url}
                    alt="Preview"
                    className="w-full max-h-96 rounded border"
                  />
                ) : (
                  <video
                    src={previewMedia.url}
                    controls
                    className="w-full h-auto rounded border"
                  />
                )
              ) : (
                <p className="text-gray-500">No media selected</p>
              )}
            </div>
          </div>
        </SlDrawer>
      )}
      {preview && (
        <SlDrawer
          label="preview"
          onSlRequestClose={handleRequestClose}
          open={preview}
          onSlAfterHide={() => {
            setPreview(false);
            setPreviewMedia(null);
          }}
        >
          {previewMedia ? (
            previewMedia.type === "image" ? (
              <img
                src={previewMedia.url}
                alt="Preview"
                className="w-full max-h-96 rounded border"
              />
            ) : (
              <video
                src={previewMedia.url}
                controls
                className="w-full h-auto rounded border"
              />
            )
          ) : (
            <p className="text-gray-500">No media selected</p>
          )}
        </SlDrawer>
      )}
      {updateStatus && (
        <SlDrawer
          label="Update"
          open={updateStatus}
          onSlRequestClose={handleRequestClose}
          onSlAfterHide={() => {
            setHelpData(null);
            setUpdateStatus(false);
            form2.reset();
          }}
        >
          <form onSubmit={form2.handleSubmit(handleUpdateHelp)}>
            <div className="mb-3">
              <label className="form-label font-semibold" htmlFor="description">
                Description
              </label>
              <p>{helpData?.description}</p>
            </div>
            <div className="mb-3">
              <label className="form-label" htmlFor="Status">
                Status
              </label>
              <select
                className="form-select"
                aria-label="Default select example"
                {...form2.register("status", { required: true })}
              >
                <option value="1">Pending</option>
                <option value="2">In Progress</option>
                <option value="3">Resolved</option>
                <option value="4">Ignore</option>
              </select>
            </div>
            <div className="mb-3">
              <label className="form-label" htmlFor="update">
                Update
              </label>
              <span className="text-red-600">*</span>&nbsp;&nbsp;{" "}
              <span
                className={`${
                  watchUpdate?.length > 100 ? "text-red-600" : "text-green-500"
                }`}
              >
                {100 - watchUpdate?.length || 100}
              </span>
              <textarea
                className="form-control"
                id="update"
                rows="3"
                {...form2.register("description", {
                  required: true,
                  minLength: 1,
                  maxLength: 100,
                })}
              ></textarea>
              {form2.formState?.errors?.description?.type === "maxLength" && (
                <p className="text-red-600">Too many Characthers</p>
              )}
              {form2.formState?.errors?.description
                ? form2.formState?.errors?.description?.type !==
                    "maxLength" && (
                    <p className="text-red-600">Please Enter Update</p>
                  )
                : null}
            </div>
            <div className="mb-3">
              <button className="btn btn-primary w-full" type="submit">
                {submitLoader && (
                  <span
                    className="spinner-grow spinner-grow-sm"
                    role="status"
                    aria-hidden="true"
                  ></span>
                )}
                {submitLoader ? "Submitting..." : "Submit"}
              </button>
            </div>
          </form>
        </SlDrawer>
      )}

      {showUpdates && (
        <SlDrawer
          label="Updates"
          onSlRequestClose={handleRequestClose}
          open={showUpdates}
          onSlAfterHide={() => {
            setShowUpdates(false);
          }}
        >
          <>
            <div className="flex flex-col gap-3">
              <div className="max-w-md p-4 border rounded-lg shadow-lg bg-white">
                <div className="flex justify-between items-center mb-3">
                  <span className="text-sm font-medium text-gray-600">
                    {formatDateWithTime(helpData.created_on)}
                  </span>
                  <span
                    className={`px-3 py-1 text-xs font-bold rounded-full 
                     bg-yellow-300 text-black`}
                  >
                    Pending
                  </span>
                </div>

                <p className="text-sm text-gray-500 mb-3">
                  👤 Created By:{" "}
                  <span className="font-medium text-gray-700">
                    {helpData.name}
                  </span>
                </p>
                <p className="text-gray-700">{helpData.description}</p>
              </div>
            </div>
            {updates?.map((update) => (
              <div className="flex flex-col gap-3">
                <div className="max-w-md p-4 border rounded-lg shadow-lg bg-white">
                  <div className="flex justify-between items-center mb-3">
                    <span className="text-sm font-medium text-gray-600">
                      {formatDateWithTime(update.updated_on)}
                    </span>
                    <span
                      className={`px-3 py-1 text-xs font-bold rounded-full 
                     ${
                       update.status === "1"
                         ? "bg-yellow-300 text-black"
                         : update.status === "2"
                         ? "bg-blue-300 !text-blue-800"
                         : update.status === "3"
                         ? "bg-green-300 !text-green-900"
                         : "bg-gray-400 !text-gray-800"
                     }`}
                    >
                      {statusMappings[update.status]}
                    </span>
                  </div>

                  <p className="text-sm text-gray-500 mb-3">
                    👤 Updated By:{" "}
                    <span className="font-medium text-gray-700">
                      {update.updated_by}
                    </span>
                  </p>
                  <p className="text-gray-700">{update.update}</p>
                </div>
              </div>
            ))}
          </>
        </SlDrawer>
      )}
      {deleteClicked && (
        <Modal
          show={deleteClicked}
          backdrop="static"
          animation={false}
          centered
          onHide={() => {
            setDeleteClicked(false);
            setDeleteId(null);
            form3.reset();
          }}
        >
          <ModalHeader closeButton>
            <ModalTitle>Ignore the issue / Misrepresentation</ModalTitle>
          </ModalHeader>
          <ModalBody>
            <form onSubmit={form3.handleSubmit(handleIgnore)}>
              <div className="mb-3">
                <label htmlFor="update" className="form-label">
                  Reason
                </label>
                <span className="text-red-600">*</span>&nbsp;&nbsp;
                <span
                  className={`${
                    watchReason?.length > 100
                      ? "text-red-600"
                      : "text-green-500"
                  }`}
                >
                  {100 - watchReason?.length || 100}
                </span>
                <textarea
                  className="form-control"
                  rows={2}
                  {...form3.register("update", {
                    required: true,
                    minLength: 1,
                    maxLength: 100,
                  })}
                ></textarea>
                {form3.formState?.errors?.update?.type === "maxLength" && (
                  <p className="text-red-600">Too many Characthers</p>
                )}
                {form3.formState?.errors?.update
                  ? form3.formState?.errors?.update?.type !== "maxLength" && (
                      <p className="text-red-600">Reason is required</p>
                    )
                  : null}
              </div>
              <div className="mb-3">
                <button type="submit" className="btn btn-primary w-full">
                  {submitLoader && (
                    <span
                      className="spinner-grow spinner-grow-sm"
                      role="status"
                      aria-hidden="true"
                    ></span>
                  )}
                  {submitLoader ? "Submitting..." : "Submit"}
                </button>
              </div>
            </form>
          </ModalBody>
        </Modal>
      )}
    </>
  );
}

export default Help;
